import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import style from './style.scss';

export default class Input extends React.PureComponent {
  static propTypes = {
    autoFocus: PropTypes.bool,
    caption: PropTypes.string,
    errorMessage: PropTypes.string,
    id: PropTypes.string,
    isInvalid: PropTypes.bool,
    label: PropTypes.oneOfType([PropTypes.element, PropTypes.string]),
    limit: PropTypes.number,
    name: PropTypes.string.isRequired,
    onChange: PropTypes.func,
    onBlur: PropTypes.func,
    placeholder: PropTypes.string,
    readOnly: PropTypes.bool,
    subText: PropTypes.string,
    type: PropTypes.string,
    value: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
    disabled: PropTypes.bool,
    className: PropTypes.string
  };

  static defaultProps = {
    errorMessage: 'error',
    isInvalid: false,
    limit: 64,
    readOnly: false,
    subText: ''
  };

  render() {
    const {
      autoFocus,
      caption,
      errorMessage,
      isInvalid,
      label,
      limit,
      name,
      onChange,
      onBlur,
      placeholder,
      readOnly,
      subText,
      type,
      value,
      options = [],
      disabled,
      className
    } = this.props;

    let id = type === 'radio' ? this.props.id : this.props.name;

    return (
      <div className={style.inputFieldContainer}>
        <div
          className={classNames(style.formInput, {
            [style.formInputError]: isInvalid,
            [style.radioInput]: type === 'radio'
          })}
        >
          {type !== 'radio' ? (
            <label htmlFor={id}>{(isInvalid && errorMessage) || label}</label>
          ) : null}
          {type !== 'select' ? (
            <input
              {...(autoFocus ? { autoFocus: true } : {})}
              id={id}
              maxLength={limit}
              name={name}
              onChange={onChange}
              onBlur={onBlur}
              placeholder={placeholder}
              readOnly={readOnly}
              type={type}
              value={value}
              className={className}
            />
          ) : (
            <select
              id={name}
              value={value}
              name={name}
              onChange={onChange}
              onBlur={onBlur}
              placeholder={placeholder}
              className={className}
              disabled={disabled}
            >
              {
                <option value="" data-default>
                  {placeholder}
                </option>
              }
              {options.map(item => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          )}
          {caption ? <div className={style.caption}>{caption}</div> : null}
          {type === 'radio' ? (
            <label htmlFor={id} className={style.radioLabel}>
              {label}
            </label>
          ) : null}
        </div>
        <div className={style.subText}>{subText}</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Input/index.js